import React, { useMemo } from "react";

const SectionHeader = ({ styles, title, desc }) => (
  <div className={styles.sectionHeader}>
    <h2 className={styles.h2}>{title}</h2>
    <div className={styles.divider} />
    {desc ? <p className={styles.sectionDesc}>{desc}</p> : null}
  </div>
);

const InfoCard = ({ styles, title, items, tone = "feature" }) => (
  <div className={`${styles.rowCard} ${tone === "benefit" ? styles.rowCardBenefit : ""}`}>
    <div className={styles.rowCardHeader}>
      <div className={styles.rowCardTitle}>{title}</div>
    </div>

    <ul className={styles.cleanList}>
      {items.map((b, i) => (
        <li key={i} className={styles.cleanListItem}>
          <span className={styles.bulletDot} />
          <span className={styles.bulletText}>{b}</span>
        </li>
      ))}
    </ul>
  </div>
);

const ConsultingResearch = ({ styles }) => {
  const data = useMemo(
    () => ({
      desc:
        "기업의 업무 구조·데이터 수준·산업 특성을 정밀 분석하여 어떤 AI 기술을 어떤 업무에 도입해야 가장 큰 비즈니스 효과를 내는지 맞춤형 전략을 제시하는 연구 분야입니다. AI 도입 타당성 분석부터 모델 선정, ROI 산정, PoC 설계까지 전 과정을 전문적으로 컨설팅합니다.",
      areas: [
        "AI 도입 타당성 및 우선순위 분석",
        "업무 프로세스·데이터 구조 분석",
        "최적 알고리즘/모델 아키텍처 선정",
        "AI 적용 시나리오 및 시스템 설계",
        "PoC(개념검증) 기획 및 효과 예측",
        "산업별 AI 로드맵 전략 수립",
      ],
      effects: [
        "AI 투자 대비 ROI 극대화",
        "잘못된 AI 도입으로 인한 비용 낭비 방지",
        "AI 적용 범위·우선순위의 명확한 로드맵 확보",
        "산업별 최적화된 모델 도입으로 성과 창출",
        "조직 내부의 디지털 전환 속도 가속화",
        "경영진 의사결정 지원(정량 분석 기반)",
      ],
      cases: [
        "국방 분야: 감염병 예측 시스템 아키텍처 기획",
        "기업: 고객지원 업무 AI 자동화 타당성 분석",
        "제조사: 설비 고장 예측 모델 도입 전략 수립",
        "교육기관: AI 기반 학사·상담 자동화 제안",
        "금융기관: 리스크 분석 모델 선정 및 도입 계획",
      ],
    }),
    []
  );

  const mapping = useMemo(
    () => [
      { type: "문서 자동화 / 상담", alg: "RAG, Fine-tuned LLM, Multi-Agent" },
      { type: "제조 검사 / 의료 영상", alg: "Vision Transformer, VLM" },
      { type: "감염병 · 기상 · 수요 예측", alg: "Temporal Fusion Transformer(TFT), LSTM, XGBoost" },
      { type: "운영 리스크 탐지", alg: "Autoencoder 기반 이상탐지, Isolation Forest" },
      { type: "제품 추천 · 개인화", alg: "DeepFM, Neural Collaborative Filtering" },
      { type: "전략 보고서 자동 생성", alg: "Instruction-tuned LLM, LLM 기반 오토메이션" },
    ],
    []
  );

  return (
    <section className={styles.section} id="research-consulting">
      <div className={styles.container}>
        <SectionHeader styles={styles} title="AI 비즈니스 컨설팅 & 알고리즘 전략 연구" desc={data.desc} />

        <div className={styles.panel}>
          <div className={styles.panelTopDots}>
            <span className={styles.panelDot} />
            <span className={styles.panelDot} />
            <span className={styles.panelDot} />
          </div>

          <div className={styles.panelBodyGrid2}>
            <InfoCard styles={styles} title="주요 연구 영역" items={data.areas} />
            <InfoCard styles={styles} title="기대되는 효과" items={data.effects}/>
          </div>

          <div className={styles.mappingWrap}>
            <div className={styles.mappingTitle}>업무 목표와 데이터 유형에 따른 추천 알고리즘</div>

            <div className={styles.mappingGrid}>
              {mapping.map((m, i) => (
                <div className={styles.mappingCard} key={i}>
                  <div className={styles.mappingType}>{m.type}</div>
                  <div className={styles.mappingAlg}>{m.alg}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={styles.subSection}>
          <SectionHeader styles={styles} title="적용 사례" />
          <div className={styles.targetWrap}>
            {data.cases.map((t, i) => (
              <div className={styles.targetItem} key={i}>
                {t}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultingResearch;
